import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { formatInTimeZone } from 'date-fns-tz';

import { ILayoutContext, LayoutContext, Store, ToastSeverityEnum } from '@uderly/react-uderly-ui';
import { Link } from 'react-router-dom';

interface LicenceProps {
  store: Store;
}

export const useLicenceUtils = () => {
  const { t } = useTranslation();

  const layoutContext = useContext(LayoutContext) as ILayoutContext;

  const warnLicenceRequired = (store) => {
    layoutContext.toast.show({
      open: true,
      severity: ToastSeverityEnum.warning,
      autoHideDuration: 7000,
      content: <>
        <p>{t("pro-licence-required")}</p>
        <Link to={"/" + store.subdomain + "/settings"}>{t('upgrade-licence', { store: store.name })}</Link>
      </>
    });
  }

  return { warnLicenceRequired };
}

const Licence = (props: LicenceProps) => {
  const { t } = useTranslation();

  const { store } = props;

  if (!store || !store.licence) return null;

  return <div className="licence-box">
    <p>
      {t('your-licence')}: <span className={'licence-type ' + store.licence.title.toLowerCase()}>{store.licence.title}</span>
    </p>

    {store.licence_ends_at &&
      <p className="licence-expiration">{t('licence-expires-on')} {
        formatInTimeZone(new Date(store.licence_ends_at), store.timezone as string, "dd/MM/yyyy H:mm")}</p>}
  </div>;
}

export default Licence;
